import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import Container from '../../../components/ui/Container';
import TypewriterText from '../../../components/ui/TypewriterText';
import MagneticButton from '../../../components/ui/MagneticButton';
import ParallaxLayer from '../../../components/ui/ParallaxLayer';

const CTASection = () => {
  const [typewriterDone, setTypewriterDone] = useState(false);

  return (
    <section className="relative py-section overflow-hidden">
      <div className="absolute inset-0 aurora-bg" />

      {/* Floating shapes */}
      <ParallaxLayer speed={0.3} className="absolute inset-0 pointer-events-none">
        <div className="absolute top-10 left-[10%] w-20 h-20 border border-white/10 rounded-full" />
        <div className="absolute bottom-20 right-[15%] w-32 h-32 border border-white/5 rounded-lg rotate-45" />
      </ParallaxLayer>
      <ParallaxLayer speed={0.5} className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/3 right-[25%] w-16 h-16 bg-white/5 rounded-full blur-xl" />
      </ParallaxLayer>

      <Container className="relative z-10 text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white mb-6 text-balance min-h-[1.2em]">
          <TypewriterText
            texts={['Ready to Transform Your Body?']}
            speed={60}
            onComplete={() => setTypewriterDone(true)}
          />
        </h2>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={typewriterDone ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-lg text-white/80 max-w-xl mx-auto mb-10 leading-relaxed"
        >
          Join hundreds of people who have already started their calisthenics journey with expert guidance.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={typewriterDone ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <MagneticButton>
            <Link
              to="/programs"
              className="glow-ring inline-flex items-center gap-2 px-8 py-4 text-lg font-semibold text-brand-800 bg-white hover:bg-gray-100 rounded-xl transition-all duration-200 shadow-lg hover:scale-105 group"
            >
              Get Started Today
              <FiArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </MagneticButton>
          <MagneticButton>
            <Link
              to="/contact-us"
              className="inline-flex items-center gap-2 px-8 py-4 text-lg font-semibold text-white bg-white/10 hover:bg-white/20 border border-white/20 rounded-xl transition-all duration-200"
            >
              Talk to Us
            </Link>
          </MagneticButton>
        </motion.div>
      </Container>
    </section>
  );
};

export default CTASection;
